import { Input, Modal } from 'antd'
import Dragger from 'antd/es/upload/Dragger'
import Spinner from 'components/Spinner'
import React, { useState } from 'react'
import { InboxOutlined } from '@ant-design/icons';
import Button from 'components/Button';
import { saveAs } from 'file-saver';
import type { UploadProps } from 'antd';
import { message } from 'antd';
import HTTPClient from 'services/HTTPClient';
import Papa from 'papaparse'

type Props = {
    onClose: () => void
}

export default function UsersImporterModal({ onClose }: Props) {
    const [isUploading, setisUploading] = useState(false)
    const [fileList, setFileList] = useState<any[]>([]);

    const onProcessComplete = async (data) => {
        try {
            let response = await HTTPClient.get().postDataForJSONResult("/api/tenant/add-users", { data })
            console.log("Upload response", response)
            message.success(`${response.users.length} Users created uploaded successfully.`);
            let csv = Papa.unparse(response.users)
            let file = new File([csv], "users.csv", { type: "text/csv;charset=utf-8" })
            saveAs(file);
        } catch (error: any) {
            message.error(`Error: ${error?.message}`);
        }

    }

    const parseCSV = (file) => {
        return new Promise((resolve, reject) => {
            Papa.parse(file, {
                header: true,
                complete: function (results) {
                    console.log(results);
                    let data = results.data
                    let requiredColumns = ["First Name", "Last Name", "Email", "Grade"]
                    let finalData: any[] = []
                    for (let i = 0; i < data.length; i++) {
                        const d = data[i];
                        const hasAllKeys = requiredColumns.every(item => d.hasOwnProperty(item));
                        const doesNotHaveAllKeys = requiredColumns.every(item => !d.hasOwnProperty(item) || !d[item]);
                        if (doesNotHaveAllKeys) {
                            continue
                        }
                        if (!hasAllKeys) {
                            reject(`Please provide all the required columns on row ${i + 1}. Download sample for reference!`)
                        }
                        finalData.push(d);
                    }
                    resolve(finalData)
                }
            });
        })
    }

    const props: UploadProps = {
        fileList,
        name: 'file',
        multiple: false,
        async beforeUpload(file, FileList) {
            console.log("beforeUpload", file)
            setFileList(FileList)
            setisUploading(true)
            try {
                let data = await parseCSV(file)
                console.log("Parsed CSV", data)
                onProcessComplete(data)
            } catch (error: any) {
                console.error(error)
                message.error(`${file.name} file upload failed. ${error?.message}`);
            }
            setisUploading(false)
            setFileList([])
            return false;
        },
        onChange(info) {
            console.log("OnChange", info)
        },
        onDrop(e) {
            console.log('Dropped files', e.dataTransfer.files);
        },
    };

    return (
        <Modal
            open
            onCancel={onClose}
            footer={null}
            width={"80vw"}
        >
            <div className='px-5 py-5'>
                <h3 className='is-size-3 mb-5 between'>
                    <strong>Import Users</strong>
                </h3>
                <div className='pb-5'>
                    <p className='mb-6 between'>
                        Drop a csv containing all the required fields
                        <Button onClick={() => {
                            saveAs("https://homieai-assets.s3.amazonaws.com/sample_users.csv", "Sample Users.csv");
                        }}>Download Sample</Button>
                    </p>
                    <Dragger  {...props}>
                        {isUploading
                            ? <Spinner className='mx-auto mt-2' />
                            : <>
                                <p className="ant-upload-drag-icon">
                                    <InboxOutlined />
                                </p>
                                <p className="ant-upload-text">Click or drag file to this area to upload</p>
                                <p className="ant-upload-hint">
                                    Supports single file only
                                </p>
                            </>
                        }
                    </Dragger>
                </div>
            </div>
        </Modal>
    )
}